export default __webpack_public_path__ + "static/media/loader.28265a53.gif";